function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  width: "28",
  height: "17",
  viewBox: "0 0 28 17",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M27.65 16.094V.907a.57.57 0 00-.583-.557H.933A.57.57 0 00.35.907v15.187a.57.57 0 00.583.556h26.134a.57.57 0 00.583-.556z",
  stroke: "#0066B2",
  strokeWidth: ".7",
  fill: "#F9F9F9"
}), React.createElement("path", {
  fill: "#0066B2",
  d: "M12.82 11.253h-1.371l.856-5.648h1.371zM10.296 5.605L8.989 9.49l-.155-.836-.46-2.54s-.056-.509-.65-.509H5.562l-.025.096s.66.147 1.434.645l1.19 4.907H9.59l2.18-5.648h-1.474zM19.568 9.256l.72-2.115.405 2.115h-1.125zm1.508 1.997h1.259l-1.098-5.648h-1.101c-.51 0-.633.42-.633.42l-2.044 5.228h1.428l.286-.838h1.742l.161.838zM17.566 6.963l.195-1.213s-.603-.246-1.232-.246c-.68 0-2.295.32-2.295 1.87 0 1.46 1.895 1.478 1.895 2.244 0 .766-1.7.629-2.261.146l-.204 1.267s.612.32 1.547.32c.935 0 2.346-.52 2.346-1.934 0-1.469-1.912-1.606-1.912-2.244 0-.639 1.334-.557 1.921-.21"
}), React.createElement("path", {
  d: "M8.834 8.654l-.46-2.54s-.056-.509-.651-.509h-2.16l-.025.096s1.038.23 2.034 1.095a4.43 4.43 0 011.262 1.858",
  fill: "#F9A533"
}))));